const ServeurIntegrated = ({language , token}) => {
    const newServeurIframe = "https:" +
    window.process.env.URL_Configuration_Server
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_serveur_display"
        src={newServeurIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default ServeurIntegrated